import { mapActions, mapGetters } from 'vuex'
import { getDefaultBinLocationId } from '@/helpers'
import { filterTaxesForSale } from '../../helpers'
import { transformQRCode } from '../../store/modules/PosQRCode'
import { transformOrderRef } from '../../lib/v-calendar/utils/helpers'
import { uuid } from 'vue-uuid'

export default {
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      txtFieldSearch: '',
      isSearchByScan: false,
      selected: {
        product: null,
        product_id: null,
      },
      lastDisplayType: '', // grid, list
      gridWidth: 200,
      gridHeight: 200,
      gridRatio: 1.10982659,

      qrcode: null,
      isSubmittedQRCodeForm: false,
      defaultValues: null,
    }
  },
  computed: {
    ...mapGetters({
      pos: 'getPos',
      display: 'getPosDisplay',
      posProducts: 'getPosProducts',
      orders: 'getPosOrders',
      getPosOrdersById: 'getPosOrdersById',
      category_id: 'getPosSelectedCategoryId', // selected category_id
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
      bills: 'getPosStockBills',
      network_status: 'getNetworkStatus', // online return true, offline return false
      lang: 'getLang',
      auth: 'getAuth',
      getMainStock: 'getMainStock', // get stock_id from primary warehouse
      posSettings: 'getPosSetting',
      customers: 'getCustomers',
      posSession: 'getPosSession',
      currency: 'getCurrency',
      defaultImages: 'getDefaultImages',
      discounts: 'getDiscounts',
      isAssignedSkuToStock: 'isAssignedSkuToStock',
      diningName: 'getPosSelectedDiningName',
      posSettings: 'getPosSetting',
      section: 'getPosSection',
      queues: 'getPosQueues',
      unreadNotificationCount: 'unreadNotificationCount',
    }),
    branch () {
      return this.$store.state.posBranch.branch
    },
    isSelectedTable () {
      return this.table_number !== null
    },
    isOffline () {
      return this.network_status == false
    },
    networkMessage () {
      if (this.network_status) {
        return this.$t('message.online')
      }
      return this.$t('message.offline')
    },
    use_queue () {
      return this.posSettings.queue.is_active
    },
    use_table () {
      return this.posSettings.table.is_active
    },
    use_dining () {
      return this.posSettings.dining.is_active
    },
    user_customer () {
      return this.posSettings.customer.is_active
    },
    products() {
      let allProducts = this.posProducts.find((item) => item.category_id == '2')
      if (allProducts) {
        allProducts = allProducts.products
      }
      return this.posProducts.map((item) => {
        if (['1', '2'].includes(item.category_id)) {
          return {
            ...item,
            productsCount: item.products.length,
          }
        }
        const products = allProducts.filter((product) => {
          return product.category_id === item.category_id
        })
        return {
          ...item,
          products: this.category_id == item.category_id ? products : [],
          productsCount: products.length,
        }
      })
    },
    filterProducts () {
      if (!this.display.search) {
        return this.products
      }

      var data = this.products
      var results = []

      data.map(row => {
        var filter_products = []
        var first = null

        if (row.category_id == '2') {
          row.products.map((p, i) => {
            let pname = p.product_name.toLowerCase()
            let txtsearch = this.txtFieldSearch.toLowerCase()
            const foundByProductName = pname.search(txtsearch) >= 0
            const foundByBarcode = p.prices.some((price) => (
              price.barcode && price.barcode.search(txtsearch) >= 0
            ))

            if (txtsearch.trim().length > 0 && (foundByProductName || foundByBarcode)) {
              if (!first) {
                first = _.cloneDeep(p)
              }
              filter_products.push(p)
            }
          })

          this.selected.product = first || null

          var clone = _.cloneDeep(row)
          clone.products = filter_products

          results.push(clone)
        }
      })

      return results
    },
    resultSearchCount () {
      if (this.display.search) {
        var count = 0
        this.filterProducts.map(row => {
          if (row.category_id == '2') {
            count = row.products.length
          }
        })
        return count
      }
      return null
    },
    isShowSearch () {
      return this.display.search
    },
    filterDiscounts() {
      return this.discounts.filter((discount) => discount.type === 'general')
    },
    showDiscountButton() {
      return this.filterDiscounts.length > 0
    },
    notfound() {
      if (this.products) {
        const item = this.products.find((item) => item.category_id == '2')
        return item ? item.products.length === 0 : false
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions([
      'addPosOrder',
      'changePosCategory',
      'setPosSelectedProduct',
      'setPosSection',
      'setPosSectionWith',
      'setPosDisplay',
      'switchLang',
      'setLastSecIsBarcode',
      'updatePosOrder',
      'setPosLocalStorage',
      'setPosSelectedTable',
      'setPosSelectedDiningName',
      'setPosSelectedCustomerId',
      'updatePosOrderDiscounts',
      'clearPosSelectedTable',
      'clearPosSelectedCustomerId',
      'clearPosSelectedDiningName',
      'setDiningNameForQueueAndTable',
      'clearPosMasterData',
      'createOrder',
    ]),
    isFixedPrice (product) {
      return product.prices.length == 1 && product.prices[0].price != null && product.modifiers.length == 0
    },
    isCustomPrice (product) {
      return product.prices.length == 1 && product.prices[0].price == null
    },
    isChooseAttr (product) {
      return product.prices.length > 1 || product.modifiers.length > 0
    },
    isSinglePriceAndIsNotAvailable (product) {
      if (product.prices.length == 1) {
        if (product.prices[0].is_available == false) {
          return true
        }
      }
      return false
    },
    isSinglePriceAndOutOfStock (product) {
      const enableSaleDisable = this.posSettings.product_out_of_stock.sale_disabled === true
      const hasOneSku = product.prices.length === 1
      const hasStocks = product.prices[0].stocks.length > 0
      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const isAssignedSkuToStock = this.isAssignedSkuToStock(branchAssignWhId, product.prices[0].sku_id)
      if (enableSaleDisable && hasOneSku && hasStocks && isAssignedSkuToStock) {
        const currentStock = product.prices[0].total_instock
        const configStockCount = this.posSettings.product_out_of_stock.count
        const isOutOfStock = currentStock <= configStockCount
        if (isOutOfStock) {
          return true
        }
      }
      return false
    },
    stockCount (product) {
      const hasOneSku = product.prices.length === 1
      const hasMoreThenOneSkus = product.prices.length > 1
      const hasStocks = product.prices[0].stocks.length > 0
      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const isAssignedSkuToStock = this.isAssignedSkuToStock(branchAssignWhId, product.prices[0].sku_id)
      if (hasOneSku && hasStocks && isAssignedSkuToStock) {
        return product.prices[0].total_instock
      } else if (hasMoreThenOneSkus && hasStocks && isAssignedSkuToStock) {
        return product.prices.reduce((acc, cur) => acc + cur.total_instock, 0)
      }
      return null
    },
    // สาขานี้มีการผูกไว้กับคลังสินค้าใดๆหรือไม่ (ผูกเพื่อตัดสต๊อก)
    isSyncWithWarehouse (product) {
      return this.stockCount(product) !== null
    },
    async selectedProduct (product) {
      // end this line is product have single price and is not available or out of stock
      if (this.isSinglePriceAndIsNotAvailable(product) || this.isSinglePriceAndOutOfStock(product)) {
        return false
      }

      let fixedPrice = this.isFixedPrice(product)
      let customPrice = this.isCustomPrice(product)
      let chooseAttr = this.isChooseAttr(product)

      if (fixedPrice) {
        const branchAssignWhId = this.$store.state.posBranch.branch.whId
        const queue_number = this.queue_number
        const table_number = this.table_number
        const stocks = product.prices[0].stocks
        const sku_id = product.prices[0].sku_id
        const item = this.getProductFullName(product.product_name, product.prices[0].attributes)
        const sku = product.prices[0]
        const price = product.prices[0].price
        const cost = product.prices[0].cost
        const quantity = 1
        const attributes = product.prices[0].attributes
        const discounts = this.setDiscounts(product.discounts, quantity)
        const taxes = filterTaxesForSale(product.taxes)
        const stock_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].stock_id : null
        const warehouse_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].warehouse_id : null
        const bin_location_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? getDefaultBinLocationId(stocks[0].stock_locations) : null
        const unit = product.unit
        const useLot = this.isProductUseLot(product)
        const useSerial = this.isProductUseSerial(product)

        if (useLot && this.isSyncWithWarehouse(product)) {
          this.lot.selected = []
          this.lot.sort.key = 'date_in'
          this.lot.sort.value = 'asc'
          this.lot.product = product
          this.lot.skuId = sku_id
          this.lot.whId = branchAssignWhId
          this.lot.isCustomPrice = false
          await this.fetchLotData()
          this.lotModal.show = true
        } else if (useSerial && this.isSyncWithWarehouse(product)) {
          this.serial.selected = []
          this.serial.sort.key = 'date_in'
          this.serial.sort.value = 'asc'
          this.serial.product = product
          this.serial.skuId = sku_id
          this.serial.whId = branchAssignWhId
          this.lot.isCustomPrice = false
          await this.fetchSerialData()
          this.serialModal.show = true
        } else {
          // add order
          const isActive_menuOnline = this.posSettings.menu_online.is_active
          const order_id = uuid.v4()
          const newOrder = {
            queue_number: queue_number,
            table_number: table_number,
            sku_id: sku_id,
            item: item,
            price: price,
            cost: cost,
            quantity: quantity,
            attributes: attributes,
            modifiers: [],
            discounts: discounts,
            taxes: taxes,
            stock_id: stock_id,
            warehouse_id: warehouse_id,
            bin_location_id: bin_location_id,
            unit: unit,
            order_id: isActive_menuOnline ? order_id : null,
          }
          this.addPosOrder(newOrder)
          this.updateDiscounts()

          /**
           * add order to firbase
           */
          if (isActive_menuOnline) {
            const payload = {
              ...transformOrderRef(newOrder),
              order_id: order_id,
              product_id: product.product_id,
              status: 'approved',
              created_at: new Date().getTime(),
            }
            this.createOrder({
              queueNumber: `${queue_number}`,
              orderId: order_id,
              payload: payload,
            })
          }
        }
      } else if (customPrice) {
        const branchAssignWhId = this.$store.state.posBranch.branch.whId
        const sku_id = product.prices[0].sku_id
        const useLot = product.prices[0].config.inventory.use_lot
        const useSerial = product.prices[0].config.inventory.use_serial

        if (useLot && this.isSyncWithWarehouse(product)) {
          this.lot.selected = []
          this.lot.sort.key = 'date_in'
          this.lot.sort.value = 'asc'
          this.lot.product = product
          this.lot.skuId = sku_id
          this.lot.whId = branchAssignWhId
          this.lot.isCustomPrice = true
          await this.fetchLotData()
          this.lotModal.show = true
        } else if (useSerial && this.isSyncWithWarehouse(product)) {
          this.serial.selected = []
          this.serial.sort.key = 'date_in'
          this.serial.sort.value = 'asc'
          this.serial.product = product
          this.serial.skuId = sku_id
          this.serial.whId = branchAssignWhId
          this.serial.isCustomPrice = true
          await this.fetchSerialData()
          this.serialModal.show = true
        } else {
          // set section
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: product,
              sku_id: product.prices[0].sku_id,
            },
          })
        }
      } else if (chooseAttr) {
        // set section
        this.setPosSectionWith({
          section: 'choose-attribute',
          data: {
            product: product,
          },
        })
      }

      // clear tooltops html (It's bug when tooltips display and selected product)
      this.removeTooltips()
    },
    transformDiscounts (selectedDiscounts) {
      const results = []
      for (const discount of selectedDiscounts) {
        const dataSet = {
          discount_id: discount.discount_id,
          discount_name: discount.discount_name,
          type: discount.type,
        }
        dataSet['value_type'] = discount.value_type
        dataSet['value_amount'] = discount.value_amount
        results.push(dataSet)
      }
      return results
    },
    selectedDiscount (discount) {
      const orders = this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      for (const order of orders) {
        const transformedDiscounts = this.transformDiscounts([discount])
        const filterDiscounts = [
          ...order.discounts,
          ...transformedDiscounts,
          // get none duplicated
        ].reduce((acc, cur) => {
          const foundIndex = acc.findIndex((item) => item.discount_id === cur.discount_id)
          if (foundIndex === -1) {
            acc.push(cur)
          }
          return acc
        }, [])
        this.updatePosOrderDiscounts({
          orderId: order.uuid,
          discounts: filterDiscounts,
        })
      }
      this.setPosDisplay({ type: this.lastDisplayType })
    },
    setRecycleScrollerGridUI() {
      if (this.display.type == 'grid') {
        var scrollerWidth = $('.wrapper-items').children().first().outerWidth()

        if (scrollerWidth != null) {
          const gWidth = scrollerWidth / 6
          this.gridWidth = gWidth
          this.gridHeight = this.gridRatio * gWidth + 6
        }
      }
    },
    setUI () {
      var orderSectionHeight = $('.orders-section').outerHeight()
      var queueBtnHeight = $('.btn-queue').outerHeight()
      var diningBtnHeight = $('.btn-dining').outerHeight()
      var customerBtnHeight = $('.btn-customer').outerHeight()
      var totalPriceHeight = $('.total-price').outerHeight()
      var buttonTableHeight = $('.btn-table').outerHeight()
      var buttonOptionsHeight = $('.btn-options').outerHeight()
      var resultHeight = 0

      resultHeight += totalPriceHeight
      resultHeight += buttonOptionsHeight

      if (this.use_queue) {
        resultHeight += queueBtnHeight
      }
      if (this.use_table) {
        resultHeight += buttonTableHeight
      }
      if (this.use_dining) {
        resultHeight += diningBtnHeight
      }
      if (this.user_customer) {
        resultHeight += customerBtnHeight
      }

      $('.order-list').css({
        height: (orderSectionHeight - resultHeight - 2) + 'px',
      })

      this.setRecycleScrollerGridUI()
    },
    handleWindowResize (event) {
      var that = this
      setTimeout(() => {
        // set ui
        that.setUI()
      }, 10)
    },
    isCustomPrice (product) {
      return product.prices.length == 1 && product.prices[0].price == null
    },
    isCustomAttr (product) {
      return product.prices.length > 1 || product.modifiers.length > 0
    },
    isCustomPriceOrAttr (product) {
      return this.isCustomPrice(product) || this.isCustomAttr(product)
    },
    onClickSwtichLang () {
      var lang
      if (this.lang == 'th') {
        lang = 'en'
      } else {
        lang = 'th'
      }
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.switchLang(lang)
    },
    getSkuByBarcode (barcode) {
      let data = this.products
      for (let i in data) {
        for (let j in data[i].products) {
          let product = data[i].products[j]
          for (let k in product.prices) {
            let sku = product.prices[k]
            if (sku.barcode && `${sku.barcode}` == `${barcode}`) {
              return sku
            }
          }
        }
      }
      return null
    },
    getProductBySku (sku_id) {
      let data = this.products
      for (let i in data) {
        for (let j in data[i].products) {
          let product = data[i].products[j]
          for (let k in product.prices) {
            let sku = product.prices[k]
            if (sku.sku_id == sku_id) {
              return product
            }
          }
        }
      }
      return null
    },
    handleBlurTxtSearch () {
      var that = this
      setTimeout(() => {
        if (that.display.search == true) {
          this.setPosDisplay({ search: false })
        }
      }, 100)
    },
    isSelectedProduct (product_id) {
      if (!this.selected.product) {
        return false
      }
      return this.selected.product.product_id === product_id && this.display.search
    },
    handleKeyup (e) {
      var that = this
      if (!this.display.search) {
        // if (e.keyCode == 83) {
        //   this.setPosDisplay({ search: true })
        // }
      } else {
        if (e.key == 'Enter') {
          if (this.isSearchByScan) {
            this.isSearchByScan = false
          } else {
            let product = this.selected.product
            if (product) {
              this.selectedProduct(product)
              setTimeout(() => {
                that.setPosDisplay({ search: false })
              }, 50)
            }
          }
        }
        if (e.key == 'Escape') {
          this.setPosDisplay({ search: false })
        }
      }
    },
    setDiscounts (discounts, quantity) {
      return discounts.map((discount) => {
        if (discount.type === 'general') {
          return {
            discount_id: discount.discount_id,
            discount_name: discount.discount_name,
            type: discount.type,
            value_type: discount.value_type,
            value_amount: discount.value_amount,
          }
        } else if (discount.type === 'conditional') {
          const getCondi = this.getDiscountCondition(discount.conditions, quantity)
          return {
            discount_id: discount.discount_id,
            discount_name: discount.discount_name,
            type: discount.type,
            value_type: getCondi ? getCondi.value_type : null,
            value_amount: getCondi ? getCondi.value_amount : null,
          }
        }
      })
    },
    updateDiscounts () {
      const { orders, discounts } = this

      orders.forEach((order) => {
        const product = this.getProductBySku(order.sku_id)
        const hasConditionDiscount = product.discounts.map(({ type }) => (type)).includes('conditional')

        if (hasConditionDiscount) {
          product.discounts.forEach((discount) => {
            const getCondi = this.getDiscountCondition(discount.conditions, order.quantity)
            const foundCondi = !!getCondi
            if (!foundCondi) {
              const foundDiscountInOrder = order.discounts.find((orderDis) => {
                return orderDis.discount_id === discount.discount_id && orderDis.value_type !== null
              })
              if (foundDiscountInOrder) {
                this.updatePosOrder({
                  ...order,
                  discounts: _.cloneDeep(order.discounts).map((orderDiscount) => {
                    if (orderDiscount.discount_id === discount.discount_id) {
                      orderDiscount.value_type = null
                      orderDiscount.value_amount = null
                    }
                    return {
                      ...orderDiscount,
                    }
                  }),
                })
                this.setPosLocalStorage({ psId: this.posSession.ps_id })
              }
            } else {
              let _orderDiscount = _.cloneDeep(order.discounts)

              const isExist = order.discounts.map((orderDiscount) => (orderDiscount.discount_id)).includes(discount.discount_id)

              if (isExist) {
                _orderDiscount.map((orderDiscount) => {
                  if (orderDiscount.discount_id === discount.discount_id) {
                    orderDiscount.value_type = getCondi.value_type
                    orderDiscount.value_amount = getCondi.value_amount
                  }
                  return {
                    ...orderDiscount,
                  }
                })
              } else {
                let newDiscount = {
                  discount_id: discount.discount_id,
                  discount_name: discount.discount_name,
                  value_type: getCondi.value_type,
                  value_amount: getCondi.value_amount,
                }
                _orderDiscount.push(newDiscount)
              }

              this.updatePosOrder({
                ...order,
                discounts: _orderDiscount,
              })

              this.setPosLocalStorage({ psId: this.posSession.ps_id })
            }
          })
        }
      })
    },
    isProductUseLot (product) {
      const isUseLot = product.prices.some((price) => price.config.inventory.use_lot)
      return isUseLot
    },
    isProductUseSerial (product) {
      const isUseSerial = product.prices.some((price) => price.config.inventory.use_serial)
      return isUseSerial
    },
    async handleSumitLotModal ({ lots }) {
      this.lotModal.show = false
      this.lot.selected = lots

      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const product = this.lot.product
      const queue_number = this.queue_number
      const table_number = this.table_number
      const stocks = product.prices[0].stocks
      const sku_id = product.prices[0].sku_id
      const item = this.getProductFullName(product.product_name, product.prices[0].attributes)
      const price = product.prices[0].price
      const cost = product.prices[0].cost
      const quantity = this.lot.selected.reduce((total, item) => total + Number(item.unit), 0)
      const attributes = product.prices[0].attributes
      const discounts = this.setDiscounts(product.discounts, quantity)
      const taxes = filterTaxesForSale(product.taxes)
      const stock_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].stock_id : null
      const warehouse_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].warehouse_id : null
      const unit = product.unit
      const mapLots = this.mapLots(this.lot.selected)

      if (this.lot.isCustomPrice) {
        this.$nextTick(() => {
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: product,
              sku_id: product.prices[0].sku_id,
              lots: mapLots,
            },
          })
        })
      } else {
        this.addPosOrder({
          queue_number: queue_number,
          table_number: table_number,
          sku_id: sku_id,
          item: item,
          price: price,
          cost: cost,
          quantity: quantity,
          attributes: attributes,
          modifiers: [],
          discounts: discounts,
          taxes: taxes,
          stock_id: stock_id,
          warehouse_id: warehouse_id,
          unit: unit,
          lots: mapLots,
        })
        this.updateDiscounts()
      }
    },
    handleCancleLotModal () {
      this.lotModal.show = false
    },
    handleCloseLotModal () {
      this.lotModal.show = false
    },
    async handleSumitSerialModal ({ serials }) {
      this.serialModal.show = false
      this.serial.selected = serials

      const branchAssignWhId = this.$store.state.posBranch.branch.whId
      const product = this.serial.product
      const queue_number = this.queue_number
      const table_number = this.table_number
      const stocks = product.prices[0].stocks
      const sku_id = product.prices[0].sku_id
      const item = this.getProductFullName(product.product_name, product.prices[0].attributes)
      const price = product.prices[0].price
      const cost = product.prices[0].cost
      const quantity = this.serial.selected.reduce((total, item) => total + Number(item.unit), 0)
      const attributes = product.prices[0].attributes
      const discounts = this.setDiscounts(product.discounts, quantity)
      const taxes = filterTaxesForSale(product.taxes)
      const stock_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].stock_id : null
      const warehouse_id = this.isAssignedSkuToStock(branchAssignWhId, sku_id) && branchAssignWhId ? stocks[0].warehouse_id : null
      const unit = product.unit
      const mapSerials = this.mapSerials(this.serial.selected)

      if (this.serial.isCustomPrice) {
        this.$nextTick(() => {
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: product,
              sku_id: product.prices[0].sku_id,
              serials: mapSerials,
            },
          })
        })
      } else {
        this.addPosOrder({
          queue_number: queue_number,
          table_number: table_number,
          sku_id: sku_id,
          item: item,
          price: price,
          cost: cost,
          quantity: quantity,
          attributes: attributes,
          modifiers: [],
          discounts: discounts,
          taxes: taxes,
          stock_id: stock_id,
          warehouse_id: warehouse_id,
          unit: unit,
          serials: mapSerials,
        })
        this.updateDiscounts()
      }
    },
    handleCancleSerialModal () {
      this.serialModal.show = false
    },
    handleCloseSerialModal () {
      this.serialModal.show = false
    },
    async onBarcode (event) {
      if (this.pos.section != 'choose-product') {
        return
      }

      if (this.isShowSearch) {
        return this.isSearchByScan = true
      }

      const barcode = event.detail.code

      this.setLastSecIsBarcode(true)

      const sku = this.getSkuByBarcode(barcode)

      if (!sku) {
        this.notify(this.$vs, {
          text: this.$t('message.notfoundbarcode', { code: barcode }),
          color: 'warning',
          icon: 'warning',
          time: 5000,
        })
      } else {
        // success
        const product = this.getProductBySku(sku.sku_id)
        const branchAssignWhId = this.$store.state.posBranch.branch.whId
        const useLot = this.isProductUseLot(product)
        const useSerial = this.isProductUseSerial(product)
        const customPrice = this.isCustomPrice(product)

        if (useLot && this.isSyncWithWarehouse(product)) {
          this.lot.selected = []
          this.lot.sort.key = 'date_in'
          this.lot.sort.value = 'asc'
          this.lot.product = product
          this.lot.skuId = sku.sku_id
          this.lot.whId = branchAssignWhId
          this.lot.isCustomPrice = customPrice
          await this.fetchLotData()
          this.lotModal.show = true
        } else if (useSerial) {
          this.serial.selected = []
          this.serial.sort.key = 'date_in'
          this.serial.sort.value = 'asc'
          this.serial.product = product
          this.serial.skuId = sku.sku_id
          this.serial.whId = branchAssignWhId
          this.serial.isCustomPrice = customPrice
          await this.fetchSerialData()
          this.serialModal.show = true
        } else if (customPrice) {
          // set section
          this.setPosSectionWith({
            section: 'custom-price',
            data: {
              product: product,
              sku_id: sku.sku_id,
            },
          })
        } else {
          // set section
          this.setPosSectionWith({
            section: 'choose-attribute',
            data: {
              product: product,
              sku_id: sku.sku_id,
            },
          })
        }
      }

      setTimeout(() => {
        this.setLastSecIsBarcode(false)
      }, 1)
    },
    onBackToDashboard() {
      this.clearPosMasterData()

      this.$router.push({ name: 'PosDashboard' })
    },
    handleRecycleScrollerReady(isReady) {
      if (isReady) {
        this.setRecycleScrollerGridUI()
      }
    },
    async handleSubmitQRCodeForm({ form, ok }) {
      this.isSubmittedQRCodeForm = true

      const data = {
        'app_provider': form.appProvider,
        'is_client_approve_access_required': form.isClientApproveAccessRequired,
        'is_client_approve_order_required': form.isClientApproveOrderRequired,
        'qrcode_type': form.qrcodeType,
        'branch_id': form.branchId,
        'table_number': form.table,
        ...((() => {
          if (form.qrcodeType === 'one_time_use') {
            return {
              ps_id: form.psId,
            }
          }
          return null
        })()),
        'expire_time_mins': form.expireTime,
        'date_code': this.moment().format('YYYYMMDD'),
      }
      const response = await this.$store.dispatch('generatePosQRCode', data)

      if (!response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.somethingwentwrong'),
          color: 'warning',
          icon: 'warning',
        })
      } else {
        const newQRCode = transformQRCode(response.data)

        ok()
        this.isSubmittedQRCodeForm = false
        this.notify(this.$vs, {
          text: this.$t('message.newqrcodecreated'),
          color: 'success',
          icon: 'cloud',
        })

        setTimeout(() => {
          this.openQRCodeImageModal(newQRCode)
        }, 100)
      }

      this.showFinish(this.$Progress)
    },
    handleOpenCreateQRCodeForm() {
      this.defaultValues = {
        appProvider: this.posSettings.menu_online.default_app_provider,
        qrcodeType: this.posSettings.menu_online.default_qrcode_type,
        isClientApproveAccessRequired: this.posSettings.menu_online.default_is_client_approve_access_required,
        isClientApproveOrderRequired: this.posSettings.menu_online.default_is_client_approve_order_required,
        expireTime: this.posSettings.menu_online.default_qrcode_expire_min,
        branchId: this.branch.branchId,
        psId: this.posSession.ps_id,
        table: '1',
      }
      this.$bvModal.show('modal-qrcode-form')
    },
    openQRCodeImageModal(qrcode) {
      this.qrcode = qrcode
      this.$bvModal.show('modal-qrcode-image')
    },
  },
  watch: {
    category_id: function () {
      $('.container-items').animate({ scrollTop: 0 }, 'fast')
    },
    isShowSearch: function (a, b) {
      let isShow = a

      this.$nextTick(function () {
        this.txtFieldSearch = ''
        this.selected.product = null
        this.changePosCategory('2')
        this.setPosDisplay({ 'search': isShow })

        if (isShow) {
          this.$refs['txtfield-search'].focus()
        }
      })
    },
    'orders': {
      handler: function (after, before) {
        var that = this
        this.$nextTick(() => {
          that.setUI()
        })
        setTimeout(() => {
          that.setPosDisplay({ search: false })
        }, 10)
      },
      deep: true,
    },
    'display.type': {
      handler: function (after, before) {
        this.lastDisplayType = before
      },
      deep: true,
    },
  },
  beforeCreate: function () {
    this.$store.dispatch('clearPosSelectedProduct')
    this.$store.dispatch('clearPosSelectedSkuId')
    this.$store.dispatch('clearPosSelectedLots')
    this.$store.dispatch('clearPosSelectedSerials')
    this.$store.dispatch('clearPosEditOrder')
  },
  created: async function () {
    let that = this

    if (this.products.length == 0) {
      await this.$store.dispatch('getPosProducts', {
        ps_id: this.$route.query.id,
      })
    }
    if (this.category_id === undefined) {
      this.changePosCategory('2')
    }

    const isRefreshPage = this.section.prev == null
    const cameBackFromPaymentSuccess = this.section.prev == 'payment-complate'
    if (this.use_dining && !this.diningName && (isRefreshPage || cameBackFromPaymentSuccess)) {
      if (!this.use_queue) {
        const defaultDining = this.posSettings.dining.options.find((item) => item.is_default).name
        this.setPosSelectedDiningName({
          name: defaultDining,
        })
        this.setDiningNameForQueueAndTable()
      }
    }

    this.lastDisplayType = this.display.type

    // set search bar to default
    this.setPosDisplay({ search: false })
    // set ui
    this.setUI()

    // binding data to parent
    this.$emit('update:ready', true)

    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init((code) => {
      this.onBarcode({ detail: { code } })
    })
  },
  mounted: function () {
    var that = this

    // set ui
    that.setUI()

    $(document).ready(function () {
      // set ui
      that.setUI()
    })

    setTimeout(() => that.setUI(), 100)

    // event keyboard
    window.addEventListener('keyup', this.handleKeyup, false)

    // resize
    window.addEventListener('resize', this.handleWindowResize)
  },
  destroyed: function () {
    // remove event keyboard
    window.removeEventListener('keyup', this.handleKeyup, false)
    // remove event resize
    window.removeEventListener('resize', this.handleWindowResize, false)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/chooseProduct.js